// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"542":"fb2d0af1","623":"b398590b","961":"613f042c"}[chunkId] + ".chunk.css";
};